





















































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import SoapDokterSvc from "@/services/SoapRanapDokter";
import SoapPerawatSvc from "@/services/SoapRanapPerawat";
import { storePasien } from "@/store/modules/pasien";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import SoapRanapStore from "@/store/modules/SoapRanapStore";
import moment from "moment";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import { storeSoap } from "@/store/modules/soap";
import { dpjpBolehVerifSoap } from "@/utils/cpptVerif";

@Component({
  inject: {
    verifikasiTerkunciFn: {
      from: "isVerifikasiTerkunci",
      default: () => () => false
    }
  }
})
export default class SoapListRecords extends Vue {
  @Prop({ default: "all" }) readonly showOnly?: "ranap" | "ralan" | "all";
  verifikasiTerkunciFn!: () => boolean;
  verificatorUserId = null;
  verifiedAt = null;
  verifying = false;

  id = null;
  subjective: string = null;
  objective: string = null;
  assesment: string = null;
  plan: string = null;
  instruksi: string = null;
  examinedAt: string | Date = null;
  isComponentJustCreated = false;

  async mounted() {
    this.getByRegister();
  }

  created() {
    this.isComponentJustCreated = true;
  }

  get isDokter() {
    return ["Dokter", "Psikolog"].includes(this.stateUser.profesi);
  }

  get isPerawat() {
    return ["Perawat", "Bidan"].includes(this.stateUser.profesi);
  }

  get showGenerateBtn() {
    return userModule.isMedis && this.soapList?.length < 1;
  }

  get soapList() {
    let list = [];
    if (this.showOnly != "all") {
      list = SoapRanapStore.soapList.filter(soap => {
        if (this.showOnly == "ralan") {
          return soap.unit_id < "50";
        } else if (this.showOnly == "ranap") {
          return soap.unit_id >= "30";
        }
      });
    } else {
      list = SoapRanapStore.soapList;
    }

    return list.map(itm => {
      itm["is_verified_ontime"] =
        moment(itm.verified_at).diff(itm.examined_at, "hours") <= 24;
      itm["verified_color"] = itm["is_verified_ontime"] ? "black" : "red";

      return itm;
    });
  }

  get loadingList(): boolean {
    return SoapRanapStore.loadingList;
  }

  get stateUser() {
    return userModule.user;
  }

  // get registerId(): number {
  //   return storePasien.identitasPasien?.register?.no
  //     ? parseInt(storePasien.identitasPasien.register.no)
  //     : this.regNo;
  // }

  get regNo(): number {
    return parseInt(this.$route.params.register);
  }

  get rmNo(): string {
    return this.$route.params.rm;
  }

  get pasienRm(): string {
    return storePasien.identitasPasien?.rm
      ? storePasien.identitasPasien.rm
      : this.rmNo;
  }

  get registerKunjungan() {
    return RegisterKunjungan.register;
  }

  get canCopy() {
    return this.stateUser.profesi == "Dokter";
  }

  get canCopySingle() {
    return this.canCopy && false;
  }

  makeNew() {
    // this.clearInput();
    this.$emit("makeNewSoap");
  }

  confirmPrompt(msg, fnCb) {
    const conf = confirm(msg);

    if (conf) {
      fnCb();
    }
  }

  async getByRegister() {
    await SoapRanapStore.getByRegister(this.regNo);

    if (this.stateUser.unit_id >= "50") {
      // untuk ngakali show verif dialog yg harus nunggu soap list terload ketika refresh/pertama component tercreate.
      if (this.soapList.length > 0 && this.isComponentJustCreated) {
        this.showVerifReviewDialog();

        this.$nextTick(() => {
          this.isComponentJustCreated = false;
        });
      }
    } else {
      await storeSoap.act_soap_on_reg(this.regNo);
    }
  }

  get verifikasiTerkunci(): boolean {
    return this.verifikasiTerkunciFn();
  }

  async verify(id, stat) {
    if (this.verifikasiTerkunci) return;
    this.confirmPrompt("Anda yakin verifikasi Catatan SOAP ini?", async () => {
      if (!this.verifying) {
        this.verifying = true;

        const SoapSvc = stat == "dr" ? SoapDokterSvc : SoapPerawatSvc;

        await SoapSvc.verify(id, {
          verificator_user_id: this.stateUser.id,
          verified_at: moment().format("YYYY-MM-DD H:m:s")
        })
          .then(() => {
            this.getByRegister();
          })
          .finally(() => {
            this.verifying = false;
          });
      }
    });
  }

  canVerifySoap(item: any) {
    return dpjpBolehVerifSoap(
      item,
      this.stateUser,
      this.registerKunjungan?.dokter?.id
    );
  }

  copySoap(item) {
    if (this.canCopy) {
      if (this.id) {
        appModule.sendErrorAlert("Copy SOAP Hanya untuk Pembuatan SOAP Baru!");
      } else {
        const soapItem = {
          id: null,
          subjective: item.subjective,
          objective: item.objective,
          assesment: item.assesment,
          plan: item.plan,
          instruksi: item.instruksi,
          examined_at: null,
          verified_at: null
        };

        this.$emit("copySoap", soapItem);
      }
    } else {
      appModule.sendErrorAlert("Akun Anda belum diperkenankan untuk Copy SOAP");
    }
    //copy soap hanya untuk pembuatan soap baru
  }

  formatDate(date) {
    return date ? moment(date).format("DD-MM-YYYY HH:mm") : null;
  }

  showEditButton(item) {
    return item.user_id == this.stateUser.id;
  }

  editSoapItem(item) {
    if (item.user.id == this.stateUser.id) {
      const soapItem = {
        ...item,
        examined_at: item.examined_at ? new Date(item.examined_at) : null,
        verified_at: item.verified_at ? new Date(item.verified_at) : null
      };

      this.$emit("editSoap", soapItem);
    } else {
      appModule.sendErrorAlert(
        "Tidak dapat mengubah SOAP yang dituliskan orang lain!"
      );
    }
  }

  subjectiveIdHovered = null;
  hoverSTimeout = undefined;
  hoverSubjective(id: number) {
    clearTimeout(this.hoverSTimeout);
    this.hoverSTimeout = setTimeout(() => {
      this.subjectiveIdHovered = id;
    }, 500);
  }
  leaveSubjective() {
    clearTimeout(this.hoverSTimeout);
    this.subjectiveIdHovered = null;
  }

  objectiveIdHovered = null;
  hoverOTimeout = undefined;
  hoverObjective(id: number) {
    clearTimeout(this.hoverOTimeout);
    this.hoverOTimeout = setTimeout(() => {
      this.objectiveIdHovered = id;
    }, 500);
  }
  leaveObjective() {
    clearTimeout(this.hoverOTimeout);
    this.objectiveIdHovered = null;
  }

  asesmenIdHovered = null;
  hoverATimeout = undefined;
  hoverAsesmen(id: number) {
    clearTimeout(this.hoverATimeout);
    this.hoverATimeout = setTimeout(() => {
      this.asesmenIdHovered = id;
    }, 500);
  }
  leaveAsesmen() {
    clearTimeout(this.hoverATimeout);
    this.asesmenIdHovered = null;
  }

  planIdHovered = null;
  hoverPTimeout = undefined;
  hoverPlan(id: number) {
    clearTimeout(this.hoverPTimeout);
    this.hoverPTimeout = setTimeout(() => {
      this.planIdHovered = id;
    }, 500);
  }
  leavePlan() {
    clearTimeout(this.hoverPTimeout);
    this.planIdHovered = null;
  }

  instruksiIdHovered = null;
  hoverInstTimeout = undefined;
  hoverInstruksi(id: number) {
    clearTimeout(this.hoverInstTimeout);
    this.hoverInstTimeout = setTimeout(() => {
      this.instruksiIdHovered = id;
    }, 500);
  }
  leaveInstruksi() {
    clearTimeout(this.hoverInstTimeout);
    this.instruksiIdHovered = null;
  }

  showVerifReviewDialog() {
    this.$emit("showVerifReview");
  }
}
